export function parseUrlParamBoolean(value: string | null): boolean | null {
  if (value === null) return null;
  const lower = value.toLowerCase();
  if (lower === "yes" || lower === "true" || lower === "1") return true;
  if (lower === "no" || lower === "false" || lower === "0") return false;
  return null;
}
